import { IconName } from '@usealloy/component-library';
import type { Option } from '@usealloy/component-library';
import { ThresholdRightAttributeOrigin } from 'flow/editor/components/NodeEditorDrawer/types';

export const NUMERIC_VALUE_MIN = -50000000;
export const NUMERIC_VALUE_MAX = 50000000;

export const configureReasonCodeGroupOption: Option = {
  label: 'Configure Reason Code Groups',
  value: 'configure_reason_code_groups',
  ctaElementProps: {
    style: {
      color: 'var(--cl-juicyBlue-600)',
    },
  },
};

export const listDelineators = new Set([',', ' ']);

export const VALID_KEY = 'isValid';
export const NOT_VALID_KEY = 'isNotValid';

export const validityBadgeUiConfig = {
  [VALID_KEY]: {
    backgroundColor: 'var(--cl-green-100)',
    icon: IconName.Approved,
  },
  [NOT_VALID_KEY]: {
    backgroundColor: 'var(--cl-red-100)',
    icon: IconName.Xmark,
  },
};

// text config pathing: originType -> dataType -> validity
export const validityBadgeTextConfig = {
  [ThresholdRightAttributeOrigin.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_REGEX]: {
    string: {
      [VALID_KEY]: 'Regex is valid.',
      [NOT_VALID_KEY]: 'Regex is not valid.',
      hyperlink: {
        text: 'Click to learn more.',
        link: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions',
      },
    },
  },
  [ThresholdRightAttributeOrigin.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_LIST_INCLUSION]: {
    // currently only rendered for number cases with invalid input
    decimal: {
      [VALID_KEY]: undefined,
      [NOT_VALID_KEY]: 'Decimal list is not valid.',
      hyperlink: undefined,
    },
    integer: {
      [VALID_KEY]: undefined,
      [NOT_VALID_KEY]: 'Integer list is not valid.',
      hyperlink: undefined,
    },
  },
};
